export default "__VITE_ASSET__Cc8XS2Lv__"